import { makeAutoObservable, runInAction } from 'mobx'
import { cloneDeep, sortBy, keyBy } from '@dt/fe-utils/dist/lodash'
import { format, getDistance, toDecimal, coordtransform, ddayjs } from '@dt/fe-utils'
import storeApi from '../../api/store.api'
import { restaurantCenter, restaurantConfig, cartMobx } from '.'
import { defaultConfig } from './cookware'

const deferred = () => {
  const result: any = {}
  result.promise = new Promise((resolve, reject) => {
    result.resolve = resolve
    result.reject = reject
  })
  return result
}

const timeDifference = (startTime: string, endTime: string): number => {
  const startF = startTime.split(':')
  const startAll = (Number(startF[0]) * 60 * 60 + Number(startF[1]) * 60 + Number(startF[2])).toFixed()
  const endF = endTime.split(':')
  const endAll = (Number(endF[0]) * 60 * 60 + Number(endF[1]) * 60 + Number(endF[2])).toFixed()
  return parseInt(String(Number(endAll) - Number(startAll)))
}

const ALLDAY = [{ 'day': 1, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 2, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 3, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 4, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 5, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 6, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }, { 'day': 7, 'list': [{ 'begin': '00:00', 'end': '24:00' }] }]

// TODO 可以再优化一次计算速度
function calInSale (saleTime: ISaleTime[], timeZone: any, nowStamp: number) {
  let isCountDown = 0
  const curDay = new Date().getDay()
  const day = curDay === 0 ? 7 : curDay // 存储当前是星期几
  const times = (saleTime || []).find((item: any) => {
    return item.day === day
  })
  if (times) {
    const valueTime = ddayjs(timeZone).format('HH:mm:ss')
    const _time = times.list.find((time) => {
      const beginTime = time.begin.split(':').join('')
      const endTime = time.end.split(':').join('')
      const now = valueTime.substr(0, 5).split(':').join('')
      if (now >= beginTime && now < endTime) {
        const endDiff = timeDifference(valueTime, `${time.end}:00`)
        isCountDown = endDiff
        return true
      } else {
        // 跨天营业时间
        if (endTime > '2400') {
          const nEnd = `${Number(endTime) - 2400}`
          const nEndH = nEnd.substr(0, nEnd.length - 2)
          const nEndM = nEnd.substr(-2)
          const _begin = '00:00'
          const _end = `0${nEndH}`.substr(-2) + `:${nEndM}`
          const _beginTime = _begin.split(':').join('')
          const _endTime = _end.split(':').join('')
          if (now >= _beginTime && now < _endTime) {
            const endDiff = timeDifference(valueTime, `${_end}:00`)
            isCountDown = endDiff
            return true
          }
        }
        const beginDiff = timeDifference(valueTime, `${time.begin}:00`)
        isCountDown = beginDiff
        return false
      }
    })
    return { inSale: !!_time, isCountDown, valueTime: nowStamp }
  }
  return { inSale: false, isCountDown, valueTime: 0 }
}

function getDistanceAndUnit (lbsLat: number, lbsLng: number) {
  const distance = getDistance(restaurantConfig.lbs.lat, restaurantConfig.lbs.lng, lbsLat, lbsLng)
  let distanceWithUnit = ''
  if (bo === 'cn') {
    if (distance < 1000) {
      distanceWithUnit = distance + 'm'
    } else {
      distanceWithUnit = toDecimal(distance / 1000, 1) + 'km'
    }
  } else {
    distanceWithUnit = toDecimal(distance / 1000, 1) + 'miles'
  }
  return { distance, distanceWithUnit }
}

class Store {
  constructor () {
    makeAutoObservable(this)
  }
  isLoading = true
  // 所有门店（pos不会维护该列表）
  storeList = [] as IStore[]
  _info: IViewMallStore = {
    storeId: 0,
    brandId: 0,
    isMobileOrder: 1,
    // isMultiMenu: 1,
    inSale: 1,
    status: 'inSale',
    saleTime: ALLDAY,
    countDownDiff: 0,
    baseTimeStamp: 0
  } as IViewMallStore

  get info (): IViewMallStore {
    const eatType = ['mall'] as ('mall')[]
    const { distance = 0, distanceWithUnit = '' } = restaurantConfig.lbs.lat ? getDistanceAndUnit(this._info.lbsLat, this._info.lbsLng) : {}
    const payMode = restaurantConfig.app === 'pos' ? this._info.payMode : restaurantConfig.codeType === 'table' ? 1 : 0
    return { ...this._info, distance, distanceWithUnit, eatType, payMode }
  }

  /** 品牌信息 */

  brand: IBrand = {
    brandId: 0,
    brandName: '',
    logo: defaultConfig.brandLogo,
    bo,
    timeZone: 'Asia/Shanghai'
  }

  /** 扩展的消费数据，当前登录用户的消费数据 （针对morder） */

  saleCntMap: {
    [storeId: number]: number;
  } = {}

  get viewStoreList (): IViewStore[] {
    if (restaurantConfig.app === 'pos') {
      return this.storeList.map(store => ({ ...store, inSale: 1, status: 'inSale', googleLbsLat: 0, googleLbsLng: 0, countDownDiff: 0, baseTimeStamp: 0, eatType: ['dinein', 'togo'] }))
    } else {
      // 当前如果是列表中的显示模式 根据断定使用storeOrderMode 即门店支持的点餐模式而非桌码的模式
      const viewList = this.storeList.map(store => {
        let lbsLat = 0
        let lbsLng = 0
        let googleLbsLat = 0
        let googleLbsLng = 0
        const storeLat = Number(store.lbsLat)
        const storeLng = Number(store.lbsLng)
        if (store.lbsType === 'google') {
          googleLbsLat = storeLat
          googleLbsLng = storeLng
          const lbsB = coordtransform.wgs84tobd09(storeLat, storeLng)
          lbsLat = lbsB[0]
          lbsLng = lbsB[1]
        } else {
          lbsLat = storeLat
          lbsLng = storeLng
          const lbsG = coordtransform.bd09towgs84(storeLat, storeLng)
          googleLbsLat = lbsG[0]
          googleLbsLng = lbsG[1]
        }
        const { distance, distanceWithUnit } = restaurantConfig.lbs.lat ? getDistanceAndUnit(storeLat, storeLng) : { distance: 0, distanceWithUnit: '' }
        let saleCnt = this.saleCntMap[store.storeId] || 0
        // TOGO
        const calcInSaleDown = calInSale(store.saleTime, store.timeZone, Date.now())
        const inSale = calcInSaleDown.inSale ? 1 : 0 as 0 | 1
        const countDownDiff = calcInSaleDown.isCountDown
        const baseTimeStamp = calcInSaleDown.valueTime
        // && !store.isMobileBookingOrder
        const status = !store.isMobileOrder ? 'closing' : inSale ? 'inSale' : 'resting' as 'closing' | 'inSale' | 'resting'
        // const eatType = Object.keys(pickBy(restaurantConfig.codeType === 'table' ? store.deskOrderMode : store.storeOrderMode)).filter(type => type === (restaurantConfig.codeType === 'table' ? 'dinein' : 'togo')) as ('dinein' | 'togo')[]
        const eatType = ('table_store'.includes(restaurantConfig.codeType) ? ['dinein'] : ['pickup']) as ('dinein' | 'pickup')[]
        // 兼容数据 当前桌码只支持堂食，门店码只支持打包
        return {
          ...store,
          lbsLat,
          lbsLng,
          lbsType: 'baidu',
          googleLbsLat,
          googleLbsLng,
          distance,
          distanceWithUnit,
          inSale,
          countDownDiff,
          baseTimeStamp,
          status,
          saleCnt,
          eatType
        }
      }).filter(store => store.status !== 'closing')
      // 1. 营业中 - 休息中可预约 - 休息中 2. 距离
      let sortList = viewList
      if (restaurantConfig.lbs.lat) {
        sortList = sortBy(viewList, 'distance')
      }
      //  + (store.isMobileBookingOrder ? 0 : 1) 暂不考虑可预约的case
      sortList = sortBy(sortList, store => (store.status !== 'resting' ? 0 : 10))
      if (restaurantConfig.codeType === 'brand' && cartMobx.info.eatType === 'delivery') {
        sortList = sortBy(sortList, (store) => store.openSelfDelivery ? 0 : 10)
      }
      if (restaurantConfig.storeId) {
        sortList = sortBy(sortList, (store) => store.storeId === restaurantConfig.storeId ? 0 : 1)
      }
      return sortList
    }
  }

  get storeIdToStore () {
    return keyBy(this.storeList, 'storeId')
  }

  get storeIdToViewStore () {
    return keyBy(this.viewStoreList, 'storeId')
  }

  /** 根据点餐类型的门店列表 */
  get eatTypeStoreMap (): TEatTypeStoreMap {
    const togoStores = this.viewStoreList.filter(store => store.storeOrderMode.togo && store.status !== 'closing')
    const dineinStores = this.viewStoreList.filter(store => store.storeOrderMode.dinein && store.status !== 'closing')
    const togoConsumedStores = sortBy(togoStores.filter(store => store.saleCnt), (store) => -(store.saleCnt || 0))
    const dineinConsumedStores = sortBy(dineinStores.filter(store => store.saleCnt), (store) => -(store.saleCnt || 0))
    return {
      togo: {
        nearbyStores: togoStores,
        consumedStores: togoConsumedStores
      },
      dinein: {
        nearbyStores: dineinStores,
        consumedStores: dineinConsumedStores
      }
    }
  }

  /** 置入已初始化的数据，针对手机点餐先预加载的模式优化（其他端暂务使用该方法） */
  async initList (data?: any) {
    const query: any = {
      brandId: restaurantConfig.brandId || 0
    }
    // if (Config.codeType && Config.codeType !== 'brand' && Config.STOREID) {
    //   query.storeId = Config.STOREID
    // }
    // 获取的时候获取全量的，根据当前是否有STOREID标记来筛选选中的门店
    const res = data || await storeApi.getHomePage(query)
    if (res && !res.error) {
      const { brandInfo = {}, storeList } = res
      // TODO 为了确保时序的正确性，使用第一家门店的timezone作为品牌的timezone
      // const brand = Object.assign(brandInfo, { timeZone: storeList.length ? storeList[0].timeZone : 'Asia/Shanghai' })
      brandInfo.logo = brandInfo.logo ? (format.toPic(brandInfo.logo)?.url || defaultConfig.brandLogo) : defaultConfig.brandLogo
      this.setBrand(brandInfo)
    }
  }

  setBrand (brand: IBrand) {
    this.brand = brand
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.BRAND_CHANGED, brand)
  }

  async initInfo (data: IViewStore) {
    this._info = cloneDeep({ ...this.info, ...data })
    restaurantCenter.setConfig({ storeId: this.info.storeId })
    if (this._info.waitingTimeConfig.status) {
      const mealsWaiting = await storeApi.getMealsWaitingTime(data.storeId)
      if (mealsWaiting) {
        Object.assign(this._info, {
          mealsWaitingTime: { ...mealsWaiting }
        })
      } else {
        Object.assign(this._info, {
          mealsWaitingTime: null
        })
      }
    } else {
      Object.assign(this._info, {
        mealsWaitingTime: null
      })
    }
    /** 触发门店修改事件 */
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.STORE_CHANGED, this.info)
  }

  /** 获取云端一家门店的信息，并置入info 针对pos端使用 */

  init () {
    // 因为有异步流程为了加快同时获取先置入品牌 门店
    this.info.brandId = restaurantConfig.brandId
    this.info.storeId = restaurantConfig.storeId
    // 如果要接入这个action 需要调解这个api
    const d = deferred()
    storeApi.getStore(this.info.brandId).then((data: any) => {
      return data
    }).then((data: any) => {
      runInAction(() => {
        this.storeList = data
        const theStore = this.viewStoreList.find(store => store.storeId === restaurantConfig.storeId)
        if (theStore) {
          // TODO 为了确保时序的正确性，使用第一家门店的timezone作为品牌的timezone
          this.setBrand({
            brandId: theStore.brandId,
            brandName: theStore.brandName || '',
            logo: (theStore as any).logo,
            bo: (theStore as any).bo,
            timeZone: theStore.timeZone
          })
          this.initInfo(theStore)
        }
        d.resolve(data)
      })
    }, (err: any) => {
      d.reject(err)
    })
    return d.promise
  }

  setSaleCntMap (saleCntMap: {
    [storeId: number]: number;
  }) {
    this.saleCntMap = saleCntMap
  }
}

export default new Store()
